import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { Button } from '@mui/material';
import React from 'react';

const NextButton = (
    { disabled, onClick }: {
        disabled: boolean;
        onClick: () => void;
    }
): JSX.Element => (
    <Button
        onClick={onClick}
        disabled={disabled}
        aria-label="Next page"
        data-testid="next-button"
    >
        <NavigateNextIcon fontSize="small"/>
    </Button>
);

export default NextButton;
